import React from 'react';
import { Form, Input, Upload } from 'antd';
import { KoButton,  Checkbox, KoText } from 'packages';
import KoIcon from '@kwapio/icons';
import Papa from 'papaparse';
import styles from './currentProperties.module.scss';

export const CheckBoxR = ({ value, onChange }) => (
  <Checkbox checked={value} onChange={e => onChange(e.target.checked)}>
        Allow Multiple Selection
  </Checkbox>
);

export const CheckBoxDisabled = ({ value, onChange }) => (
  <Checkbox checked={value} onChange={e => onChange(e.target.checked)}>
       Disable Past Date
  </Checkbox>
);

export const CheckBoxTime = ({ value, onChange }) => (
  <Checkbox checked={value} onChange={e => onChange(e.target.checked)}>
      Date with Time
  </Checkbox>
);

export const CheckBoxSecond = ({ value, onChange }) => (
  <Checkbox checked={value} onChange={e => onChange(e.target.checked)}>
      Seconds required
  </Checkbox>
);

export const CheckBoxH = ({ value, onChange }) => (
  <Checkbox checked={value} onChange={e => onChange(e.target.checked)}>
        Mark as Horizontal
  </Checkbox>
);

const OptionsList = () => {
  const handleCSV = (file, add) => {
    const reader = new FileReader();
    reader.onload = e => {
      const csvData = Papa.parse(e.target.result, { header: true, skipEmptyLines: true });
      if (csvData.data && csvData.data.length > 0) {
        const seen = new Set();
        csvData.data.forEach((row, i) => {
          const val = row.value?.trim();
          if (val && !seen.has(val)) {
            seen.add(val);
            add({ value: i + 1, label: val });
          }
        });
      }
    };
    reader.readAsText(file);
    return false;
  };

  return (
    <Form.List name={["options"]}>

      {(fields, { add, remove, move }) => (
        <>
          <div className={styles.list}>
            {fields.map((field, index) => {

              return (
                <div key={field.key} className={styles.listItem}>
                  <KoText className={styles.listLabel} text={`${index + 1}.`} />
                  <Form.Item name={[field.name, "value"]} initialValue={index + 1} hidden>
                    <Input type="hidden" />
                  </Form.Item>
                  <Form.Item
                    {...field}
                    name={[field.name, "label"]}
                    rules={[{ required: true, message: "Please enter option" }]}
                  >
                    <Input placeholder="Enter option value" />
                  </Form.Item>
                  <div className={styles.actionsBtn}>
                    <KoButton icon={<KoIcon width={12} height={12} name="ArrowLineUpOutlined" />} onClick={() => move(index, index - 1)} disabled={index === 0} />
                    <KoButton icon={<KoIcon width={12} height={12} name="ArrowLineDownOutlined" />} onClick={() => move(index, index + 1)} disabled={index === fields.length - 1} />
                    <KoButton icon={<KoIcon width={12} height={12} name="DeleteOutlined" />} onClick={() => remove(field.name)} />
                  </div>
                </div>
              );
            })}
          </div>
          <div className={styles.addOption}>
            <KoButton
              type="primary"

              label="Add Option"
              icon={<KoIcon name="PlusOutlined" color='#FFF' />}
              onClick={() => add({ value: fields.length + 1, label: "" })}
            />
            <Upload beforeUpload={file => handleCSV(file, add)} showUploadList={false}>
              <KoButton block type="primary" label="CSV" icon={<KoIcon name="UploadOutlined" />} />
            </Upload>
          </div>
        </>
      )}
    </Form.List>
  );
};

export default OptionsList;
